import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { getIpAddress } from "src/helpers/helpers.module";
import { jsonToForm, UrlHelper } from "src/helpers/helpersUtil";

interface LayoutContentContextValue {
  layoutContent: string | null;
}

const LayoutContentContext = createContext<LayoutContentContextValue>({
  layoutContent: null,
});

/** Fetch the TICCA branding content used by the login background layout. */
async function fetchLayoutContent(): Promise<string | null> {
  try {
    const result = await axios.post(
      UrlHelper.getPublicContent(),
      jsonToForm({
        form_lat: 0,
        form_lon: 0,
        ip_address: await getIpAddress(),
        post_id: 12866,
      }),
      {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      }
    );
    return result.data?.status === 200 ? (result.data.content ?? null) : null;
  } catch (err) {
    return null;
  }
}

/**
 * Provides the background layout content to every route. Fetched once when the
 * app mounts (in AppLayout) so navigating between pages doesn't refetch.
 */
export const LayoutContentProvider = ({ children }: { children: React.ReactNode }) => {
  const [layoutContent, setLayoutContent] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchLayoutContent().then((content) => {
      if (!cancelled) {
        setLayoutContent(content);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LayoutContentContext.Provider value={{ layoutContent }}>
      {children}
    </LayoutContentContext.Provider>
  );
};

/** Returns the background layout content string (parsed lines live in LayoutWithBackground). */
export const useLayoutContent = () => useContext(LayoutContentContext);